module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-view', {
    attrs: {
      "shop": _vm.shop
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2675873f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/chainmanage/routerHub.vue
// module id = 799
// module chunks = 1